export default __webpack_public_path__ + "static/media/sidebar-beige.5b2ada3f.png";